import React from "react";
import LegalLayout from "./LegalLayout";

export default function PrivacyPolicy() {
  return (
    <LegalLayout title="Privacy Policy" updated="February 2026" testId="page-privacy">
      <h2>1. Overview</h2>
      <p>
        ScanMint provides QR-based vehicle verification tools for property managers,
        restaurants, and other businesses. This Privacy Policy explains what
        information we collect, how we use it, and the choices you have.
      </p>

      <h2>2. Information we collect</h2>
      <p>
        We collect information you provide directly when you create an account,
        set up a property, or add records to your workspace. This includes:
      </p>
      <ul>
        <li>Account information — name, email, hashed password, role.</li>
        <li>
          Property and customer data — property addresses, tenant names, unit
          numbers, vehicle details (make, model, plate, color), and any contact
          information you choose to add.
        </li>
        <li>
          Billing information — billing email and payment status. Card and bank
          details are processed and stored by Stripe; ScanMint does not store
          full card or bank account numbers.
        </li>
        <li>
          Usage data — scan logs, login attempts, IP addresses, and basic
          device/browser information used for security and product analytics.
        </li>
      </ul>

      <h2>3. How we use your information</h2>
      <ul>
        <li>To operate the ScanMint service and your QR verification workflows.</li>
        <li>To process the $99 setup fee and the per-car monthly billing.</li>
        <li>To send transactional emails (invoices, receipts, suspension notices, password resets).</li>
        <li>To detect and prevent abuse, including brute-force login attempts.</li>
        <li>To improve product reliability and performance.</li>
      </ul>

      <h2>4. Public scan pages</h2>
      <p>
        ScanMint QR codes link to a public scan page that shows only the
        information needed to verify a vehicle (such as vehicle, unit, and the
        tenant contact when the QR is active). Personally identifying details are
        hidden when a QR is pre-enrollment, suspended, or inactive.
      </p>

      <h2>5. Data sharing</h2>
      <p>
        We do not sell your data. We share information only with vetted service
        providers required to operate the platform — for example, Stripe for
        payments and Resend for transactional email — and only to the extent
        necessary to deliver those services. We may also disclose information if
        legally required.
      </p>

      <h2>6. Data retention</h2>
      <p>
        We retain account, property, tenant, vehicle, and billing records for as
        long as your account is active. You may request deletion of your
        workspace data at any time by contacting support. Some records may be
        retained for legal, accounting, or fraud-prevention purposes.
      </p>

      <h2>7. Security</h2>
      <p>
        Passwords are stored hashed. Connections are encrypted in transit. Access
        to production systems is restricted to authorized personnel. No method
        of transmission or storage is 100% secure, but we work to protect your
        data using industry-standard practices.
      </p>

      <h2>8. Your choices</h2>
      <ul>
        <li>You can update your account information from the Settings screen.</li>
        <li>You can cancel your subscription at any time — there is no long-term contract.</li>
        <li>You can request export or deletion of your workspace data by contacting support.</li>
      </ul>

      <h2>9. Children</h2>
      <p>ScanMint is intended for business use and is not directed to children under 13.</p>

      <h2>10. Contact</h2>
      <p>
        Questions about this Privacy Policy can be sent to{" "}
        <a href="mailto:support@scanmint.app">support@scanmint.app</a>.
      </p>
    </LegalLayout>
  );
}
